import React from "react";
import { X, Check } from "lucide-react";

const ROWS = [
  {
    label: "Actually finishes tasks",
    shite: "Just suggests next steps",
    clyde: "Direct-execution agent",
  },
  {
    label: "DM automation",
    shite: "Unofficial scripts — banned in days",
    clyde: "Meta-verified, never shadowbanned",
  },
  {
    label: "Content distribution",
    shite: "Pastes into your CMS, hope for the best",
    clyde: "Syndicated to authority networks",
  },
  {
    label: "Local ad reach",
    shite: "Generic Meta ads, nothing local",
    clyde: "Mogul Sync local newsroom network",
  },
  {
    label: "Owner's accent",
    shite: "Corporate Silicon Valley slop",
    clyde: "Glasgow-built. Plain talking. Brutal.",
  },
];

const WhyClydeFlow = () => {
  return (
    <section id="why" className="relative py-24 lg:py-32 border-y border-white/10 bg-[#070F1B]" data-testid="why-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-400 mb-4">
              Why ClydeFlow?
            </p>
            <h2
              className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-white tracking-tighter leading-[1.05]"
              data-testid="why-headline"
            >
              The rest is{" "}
              <span className="line-through text-slate-500 decoration-cyan-400/60 decoration-4">
                shite.
              </span>
              <br />
              This one works.
            </h2>
            <p className="mt-6 text-lg text-slate-300 max-w-md">
              Most "AI tools" are dressed-up autocomplete. Pretty demos, no
              follow-through. ClydeFlow was built by people who actually run
              businesses — and got sick of cleaning up after chatbots.
            </p>
            <div className="mt-8 inline-flex items-center gap-3 px-4 py-3 border border-cyan-400/30 bg-cyan-400/5">
              <span className="h-2 w-2 rounded-full bg-cyan-400 animate-pulse" />
              <span className="font-mono text-xs uppercase tracking-[0.2em] text-cyan-200">
                No fluff. No "ideation". Just shipped work.
              </span>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-px bg-white/10 border border-white/10 rounded-sm overflow-hidden">
              <div className="bg-[#050B14] p-5">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                  Generic AI tools
                </p>
                <p className="mt-1 font-heading text-xl font-bold text-slate-400">Shite.</p>
              </div>
              <div className="bg-[#050B14] p-5">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-cyan-400">
                  ClydeFlow
                </p>
                <p className="mt-1 font-heading text-xl font-bold text-white">The Flow.</p>
              </div>

              {ROWS.map((row, i) => (
                <React.Fragment key={i}>
                  <div className="bg-[#0A192F] p-5 flex items-start gap-3" data-testid={`why-row-shite-${i}`}>
                    <X size={18} className="text-red-400/70 shrink-0 mt-0.5" />
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-1">
                        {row.label}
                      </p>
                      <p className="text-slate-300 text-sm leading-relaxed">{row.shite}</p>
                    </div>
                  </div>
                  <div className="bg-[#0A192F] p-5 flex items-start gap-3" data-testid={`why-row-clyde-${i}`}>
                    <Check size={18} className="text-cyan-300 shrink-0 mt-0.5" />
                    <div>
                      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-cyan-400 mb-1">
                        {row.label}
                      </p>
                      <p className="text-white text-sm leading-relaxed">{row.clyde}</p>
                    </div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyClydeFlow;
